import { render, staticRenderFns } from "./OpenDataContentForm.vue?vue&type=template&id=4acf9113&scoped=true"
import script from "./OpenDataContentForm.vue?vue&type=script&lang=js"
export * from "./OpenDataContentForm.vue?vue&type=script&lang=js"
import style0 from "./OpenDataContentForm.vue?vue&type=style&index=0&id=4acf9113&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acf9113",
  null
  
)

export default component.exports